import { Controller } from '@hotwired/stimulus';
import { slideDown, slideUp } from 'manage/utils/slide';

export default class extends Controller {
  static targets = ['list'];

  // action="mouseover->header-sub-menu#open"
  open() {
    this.element.classList.add('is-selected');
    slideDown(this.listTarget);
  }

  // action="mouseout->header-sub-menu#close"
  close() {
    this.element.classList.remove('is-selected');
    slideUp(this.listTarget);
  }
}
